<app-modal
  id="captureModal"
  [title]="'captureImage' | translate"
  [submitText]="'download' | translate"
  [cancelText]="'cancel' | translate"
  (handleOnSubmit)="download()"
>
  <div>
    <img [src]="captureCanvasData" [alt]="imageName" />
  </div>
</app-modal>
